import React, { useEffect, useState, } from 'react'
import Swal from 'sweetalert2';
import { collection, doc, getDoc, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import moment from 'moment';
import { Autocomplete, TextField } from '@mui/material';
import Reportmenu from '../panel/Reportmenu';

function Customerwise() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [bookings, setbookings] = useState([]);
    const [customers, setcustomers] = useState([]);
    const [customer, setcustomer] = useState();
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [searchText, setsearchText] = useState("");
    const [bookingId, setbookingId] = useState("");

    const [value, setValue] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData1()
    }, []);


    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'customers'))
            onSnapshot(q, (querySnapshot) => {
                setcustomers(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    label: doc.data().customerData.custname + " | " + doc.data().customerData.mobile,
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchCustomerBookings = () => {
        if (value) {
            setbookings([])
            let custid = value.id;
            const q = query(collection(db, 'bookings'), orderBy("checkindate", "asc"), where('customerId', '==', custid), where('status', '==', "Checkout"))
            onSnapshot(q, (querySnapshot) => {
                setbookings(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });

        }

    }


    return (
        <div>
            <Reportmenu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ textTransform: "uppercase" }} >|| Customerwise Report ||</button>
                        <div className="card card-primary card-outline mt-2">
                            <div className="row p-2">
                                <div className="col-sm-6">
                                    <Autocomplete
                                        disablePortal
                                        options={customers}
                                        sx={{ width: "100%" }}
                                        size='small'
                                        value={value}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                        inputValue={inputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setInputValue(newInputValue);
                                        }}
                                        renderInput={(params) => <TextField {...params} label="Serach here" />}
                                    />

                                </div>
                                <div className='col-sm-3'>
                                    <button onClick={fetchCustomerBookings} style={{ marginTop: 0 }} className='btn btn-info'>Fetch Data</button>
                                </div>
                            </div>

                            <div className="card-body table-responsive p-0" >
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Customer Name </th>
                                            <th>Mobile </th>
                                            <th>Checkin Date </th>
                                            <th>Checkout Date </th>
                                            <th style={{ width: 200 }}>Rooms </th>
                                            <th>Plans </th>
                                            <th>Adults </th>
                                            <th style={{ textAlign: "right" }}>Total</th>
                                            <th style={{ textAlign: "right" }}>Paid</th>
                                            <th style={{ textAlign: "right" }}>Remaining</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            bookings.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td style={{ textTransform: "capitalize" }}>{item.data.customers.custname}</td>
                                                    <td>{item.data.customers.mobile} </td>
                                                    <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                                                    <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                                                    <td>
                                                        <div className='row'>
                                                            {item.data.rooms.map((item1, index) =>
                                                                <span>{item1.roomname} &nbsp;  </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='row'>
                                                            {item.data.rooms.map((item1, index) =>
                                                                <span>{item1.plananme} &nbsp;  </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>{item.data.adults} Persons</td>
                                                    <td style={{ textAlign: "right" }}>{item.data.totalamount.toFixed(2)}</td>
                                                    <td style={{ textAlign: "right" }}>{item.data.advance.toFixed(2)}</td>
                                                    <td style={{ textAlign: "right" }}>{item.data.remaining.toFixed(2)}</td>
                                                    <td>
                                                        <a href={'/print-invoice/' + item.id} className='btn btn-info btn-sm'><i className="fa fa-print"></i></a>&nbsp;
                                                        {/* <a href={'view-details/' + item.id} className='btn btn-info btn-sm'><i className="fa fa-eye"></i></a>&nbsp; */}
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Customerwise
